import type { ReactNode } from "react"
import { usePage } from "@inertiajs/react"
import { useTranslation } from "react-i18next"
import { BotMessageSquare, LogOut, FolderX } from "lucide-react"
import { getMetaValue } from "@/utils/meta.utils"
import { Button } from "@/components/ui/button"
import backgroundImage from "@/images/bg.webp"

type WorkspaceMissingProps = {
  organizationName: string
}

const WorkspaceMissingPage = () => {
  const { organizationName } = usePage<WorkspaceMissingProps>().props
  const { t } = useTranslation()

  const handleSignOut = async () => {
    try {
      await fetch("/users/sign_out", {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": getMetaValue("csrf-token")
        }
      })
    } finally {
      window.location.href = "/login"
    }
  }

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
          <div className="flex items-center gap-2 font-medium">
            <div className="bg-primary text-primary-foreground flex size-6 items-center justify-center rounded-md">
              <BotMessageSquare className="size-4" />
            </div>
            {organizationName}
          </div>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-sm text-center">
            <div className="mb-6 flex justify-center">
              <FolderX className="text-muted-foreground size-16" />
            </div>
            <h1 className="text-2xl font-bold tracking-tight">{t("landing.workspaceMissing.title")}</h1>
            <p className="text-muted-foreground mt-2">{t("landing.workspaceMissing.description")}</p>
            <Button variant="outline" className="mt-6" onClick={handleSignOut}>
              <LogOut className="size-4" />
              {t("landing.workspaceMissing.signOut")}
            </Button>
          </div>
        </div>
      </div>
      <div className="bg-muted relative hidden lg:block">
        <img
          src={backgroundImage}
          alt={t("landing.workspaceMissing.backgroundAlt")}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
    </div>
  )
}

WorkspaceMissingPage.layout = (page: ReactNode) => page

export default WorkspaceMissingPage
